import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
export const TableSettingsColumnButtons = props => {
    const { column, index, columnDetails, columnOrder, openColumnsDetails, disabled, onMoveColumn, onOpenDetails } = props;
    const navButtonBase = classNames('btn btn-muted btn-icon-only btn-sm');
    const columnUpClasses = classNames(navButtonBase, index === 0 && 'disabled');
    const columnDownClasses = classNames(navButtonBase, index === columnOrder.length - 1 && 'disabled');
    const toggleIconClassNames = classNames('rioglyph', openColumnsDetails[column] ? 'rioglyph-remove' : 'rioglyph-width');
    return (_jsxs("div", Object.assign({ className: 'table-settings-item-item-buttons' }, { children: [!disabled && (_jsx("div", Object.assign({ className: columnUpClasses, onClick: event => {
                    event.preventDefault();
                    event.stopPropagation();
                    onMoveColumn(column, index - 1, true);
                } }, { children: _jsx("span", { className: 'rioglyph rioglyph-arrow-up' }) }))), !disabled && (_jsx("div", Object.assign({ className: columnDownClasses, onClick: event => {
                    event.preventDefault();
                    event.stopPropagation();
                    onMoveColumn(column, index + 1, true);
                } }, { children: _jsx("span", { className: 'rioglyph rioglyph-arrow-down' }) }))), columnDetails && (_jsx("div", Object.assign({ className: navButtonBase, onClick: () => onOpenDetails(column) }, { children: _jsx("span", { className: toggleIconClassNames }) })))] })));
};
TableSettingsColumnButtons.defaultProps = {
    column: '',
    index: 0,
    columnOrder: [],
    openColumnsDetails: {},
    onMoveColumn: () => undefined,
    onOpenDetails: () => undefined,
};
TableSettingsColumnButtons.propTypes = {
    column: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    columnOrder: PropTypes.arrayOf(PropTypes.string).isRequired,
    openColumnsDetails: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    columnDetails: PropTypes.object,
    onMoveColumn: PropTypes.func,
    onOpenDetails: PropTypes.func,
};
